import ACTIONS from "../../constants/constants"

export const addProductArray = payload => ({
  type: ACTIONS.ADD_PRODUCT_ARRAY,
  payload,
})
